import { InjectedConnector } from '@web3-react/injected-connector'
// import { WalletLinkConnector  } from '@web3-react/'
// import { InjectedConnector } from '@web3-react/injected-connector'

export const injected = new InjectedConnector({
    supportedChainIds: [1, 3, 4, 5, 42],
})